import { z } from 'zod';
import { ControllerRenderProps } from 'react-hook-form';
import { parseISO, startOfToday } from 'date-fns';

export const submitFormSchema = z
  .object({
    notificationEmails: z
      .array(z.string().email('Please enter a valid email address'))
      .min(1, 'At least one email address is required'),
    referenceId: z
      .string()
      .max(512, 'Reference ID must be 512 characters or less')
      .optional(),
    requestReason: z.enum(['upcoming-appointment', 'information-gathering'], {
      message: 'Request reason is required',
    }),
    dateNeededBy: z.string().optional(),
  })
  .refine(
    (data) => {
      // Date is required only for upcoming appointment
      return (
        data.requestReason !== 'upcoming-appointment' || !!data.dateNeededBy
      );
    },
    {
      message: 'Date needed by is required for upcoming appointments',
      path: ['dateNeededBy'],
    },
  )
  .refine(
    (data) => {
      // Validate that date is in the future for upcoming appointments
      if (data.requestReason === 'upcoming-appointment' && data.dateNeededBy) {
        const selectedDate = parseISO(data.dateNeededBy);
        return selectedDate > startOfToday();
      }
      return true;
    },
    {
      message: 'Date must be after today',
      path: ['dateNeededBy'],
    },
  );

export type SubmitFormType = z.infer<typeof submitFormSchema>;

export type SubmitFormFieldProps<T extends keyof SubmitFormType> = {
  field: ControllerRenderProps<SubmitFormType, T>;
};
